import { devicesSlice } from "./reducer";

export const {
  receivedPresence,
  receivedRoster,
  removePairedDevice,
  updatePairedDevice,
  addNearbyDevice,
  removeNearbyDevice
} = devicesSlice.actions;
